/**
 * Send a EZVK request
 * @param {string[]} familyNrns
 * @param {string} otherNrn
 * @returns {Promise<any>}
 * @throws {error} Throws an unexpected server error
 */
export async function sendEzvkRequest (familyNrns, otherNrn) {
  const response = await fetch('/ezvk-app/api/ezvk/order', {
    method: 'post',
    headers: {
      'CMC-Accept-Version': '1',
      'CMC-Api-Key': 'CMC_WEB',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ familyNrns, otherNrn }),
  });
  if (response.status !== 200) {
    const error = new Error('Unexpected service error');
    error.code = 'unexpected_service_error';
    throw error;
  }
  return response.json();
}
